export default __webpack_public_path__ + "static/media/banner_1.0d4e0d62.JPG";